import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useQueryKeys } from '@/shared/hooks/use-query-keys';
import { useWorkspaceId } from '@/shared/hooks/use-workspace-id';
import { createDiscoverySession } from '../api';

export function useCreateDiscoverySession() {
  const { workspaceId } = useWorkspaceId();
  const queryClient = useQueryClient();
  const queryKeys = useQueryKeys();

  return useMutation({
    mutationFn: () => createDiscoverySession(workspaceId),
    onSuccess: (response) => {
      if (!response) return;
      queryClient.invalidateQueries({ queryKey: queryKeys.discovery.currentSession() });
    },
  });
}
